var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommands({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Commands") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DataGate-LP---Action-Buttons",
    transform: "translate(-1222.000000, -427.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Commands",
    transform: "translate(1222.000000, 427.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19,13 L17,13 L17,12 C17,10.346 15.654,9 14,9 L11,9 L11,7 L13,7 C13.552,7 14,6.552 14,6 L14,1 C14,0.448 13.552,0 13,0 L7,0 C6.448,0 6,0.448 6,1 L6,6 C6,6.552 6.448,7 7,7 L9,7 L9,9 L6,9 C4.346,9 3,10.346 3,12 L3,13 L1,13 C0.448,13 0,13.448 0,14 L0,19 C0,19.552 0.448,20 1,20 L7,20 C7.552,20 8,19.552 8,19 L8,14 C8,13.448 7.552,13 7,13 L5,13 L5,12 C5,11.449 5.449,11 6,11 L14,11 C14.551,11 15,11.449 15,12 L15,13 L13,13 C12.448,13 12,13.448 12,14 L12,19 C12,19.552 12.448,20 13,20 L19,20 C19.552,20 20,19.552 20,19 L20,14 C20,13.448 19.552,13 19,13",
    id: "Fill-1265"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommands);
export default __webpack_public_path__ + "static/media/commands.0311071eac04fcaf967673dd753ba924.svg";
export { ForwardRef as ReactComponent };